import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchBanners,
  createBanner,
  updateBanner,
  deleteBanner,
} from "./slices/BannerSlice"; // Adjust import path if needed
import './Banner.css'
function Banner() {
  const dispatch = useDispatch();
  const { banners } = useSelector((state) => state.banners);
  const [bannerText, setBannerText] = useState("");
  const [isVisible, setIsVisible] = useState(true);
  const [editing, setEditing] = useState(false); // New state to track if we're editing a banner
  const businessId = "6709f0331882028713f23319";

  useEffect(() => {
    // Fetch existing banners when the component mounts
    dispatch(fetchBanners(businessId));
  }, [dispatch, businessId]);

  const handleTextChange = (e) => {
    if (e.target.value.length <= 150) {
      setBannerText(e.target.value);
    }
  };

  const handleVisibilityChange = () => {
    setIsVisible(!isVisible);
  };

  const handleSaveBanner = () => {
    if (editing) {
      // If editing, update the banner
      const bannerId = banners[0]?._id; // Assuming you are working with a single banner for now
      dispatch(updateBanner({ bannerId, title: bannerText, description: bannerText }));
    } else {
      // Create a new banner
      dispatch(createBanner({ title: bannerText, description: bannerText, businessId }));
    }
    setEditing(false); // Reset editing state after saving
  };

  const handleDeleteBanner = (bannerId) => {
    // Add confirmation before deleting
    const confirmDelete = window.confirm("Are you sure you want to delete this banner?");
    if (confirmDelete) {
      dispatch(deleteBanner({ bannerId, businessId }));
    }
  };

  return (
    <div className="banner-section">
            {/* Show existing banners */}
      <div className="existing-banners">
        <h3>Existing Banners:</h3>
        {banners.length > 0 ? (
          banners.map((banner) => (
            <div key={banner._id} className="banner-item">
              <p>{banner.title}</p>
              <button onClick={() => setEditing(true)}>Edit</button>
              <button onClick={() => handleDeleteBanner(banner._id)}>
                Delete
              </button>
            </div>
          ))
        ) : (
          <p>No banners available.</p>
        )}
      </div>
      <div className="banner-new">
        <h2>Banner Settings</h2>
        <div>
          <input
            type="checkbox"
            checked={isVisible}
            onChange={handleVisibilityChange}
          />
          <label>Show Banner</label>
        </div>

        <h3>Banner Preview:</h3>
        {isVisible && bannerText && (
          <div className="banner-preview">
            <p>{bannerText}</p>
          </div>
        )}
        <div className="banner-edit">
          <textarea
            value={bannerText}
            onChange={handleTextChange}
            placeholder="Enter banner text (max 150 characters)"
          />
          <p>{150 - bannerText.length} characters left</p>
          <button className="banner-save" onClick={handleSaveBanner}>
            {editing ? "Update Banner" : "Create Banner"}
          </button>
        </div>
      </div>

    </div>
  );
}

export default Banner;
